<template>
  <v-btn
    text
    rounded
    class="ml-2"
    color="info"
    small
    @click="atualizarAtestados()"
    :loading="carregando"
  >
    <v-icon size="18" class="mr-1">mdi-refresh</v-icon> Atualizar</v-btn
  >
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({
    carregando: false,
  }),
  methods: {
    ...mapActions("atestado", ["getAtestados"]),
    async atualizarAtestados() {
      this.carregando = true;
      await this.getAtestados();
      this.carregando = false;
    },
  },
};
</script>

<style>
</style>